export default __webpack_public_path__ + "static/media/nap5.701bd3eb.png";